export class WorkflowExecutionTracker {
    constructor(workflow) {
        this.itemsContextId = new Set();
        this.workflow = workflow;
    }
    addInputItemToProcess(contextId) {
        this.itemsContextId.add(contextId);
    }
    processInputItem(contextId) {
        this.itemsContextId.delete(contextId);
    }
    countItemsToProcess(scopeContextId) {
        let count = 0;
        for (const contextId of this.itemsContextId) {
            if (contextId.indexOf(scopeContextId) === 0) {
                count += 1;
            }
        }
        return count;
    }
}
//# sourceMappingURL=local-workflow-execution-tracker.js.map